<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                    <!--  <span v-else>{{ formatDate(jsonData.dataInizio) }}</span> -->
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-if="!isReadOnly" v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                    <!--      <span v-else>{{ formatDate(jsonData.dataFine) }}</span> -->
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Uso Di Sostante</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.usoSostanze" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.usoSostanze }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.usoSostanze === 'SI'" v-model="jsonData.usoSostanzeDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.usoSostanze === 'SI'">{{ jsonData.usoSostanzeDettaglio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Alcolista</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.alcolista" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.alcolista }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.alcolista === 'SI'" v-model="jsonData.alcolistaDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.alcolista === 'SI'">{{ jsonData.alcolistaDettaglio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Familiarita' Patologica</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.familiaritaPatologica" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.familiaritaPatologica }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.familiaritaPatologica === 'SI'" v-model="jsonData.familiaritaPatologicaDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.familiaritaPatologica === 'SI'">{{ jsonData.familiaritaPatologicaDettaglio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Precedenti Ricoveri In Strutture Private</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.precedentiRicoveriStrutturePrivate" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.precedentiRicoveriStrutturePrivate }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.precedentiRicoveriStrutturePrivate === 'SI'" v-model="jsonData.precedentiRicoveriStrutturePrivateDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.precedentiRicoveriStrutturePrivate === 'SI'">{{ jsonData.precedentiRicoveriStrutturePrivateDettaglio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Precedenti Ricoveri Volontari In SPDC </label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.precedentiRicoveriSpdc" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.precedentiRicoveriSpdc }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.precedentiRicoveriSpdc === 'SI'" v-model="jsonData.precedentiRicoveriSpdcDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.precedentiRicoveriSpdc === 'SI'">{{ jsonData.precedentiRicoveriSpdcDettaglio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Precedenti Ricoveri TSO In SPDC</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.precedentiRicoveriTso" :options="profiloSanitarioIntegrativoOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                    <span v-else>{{ jsonData.precedentiRicoveriTso }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px">
                    <b-form-textarea v-if="!isReadOnly && jsonData.precedentiRicoveriTso === 'SI'" v-model="jsonData.precedentiRicoveriTsoDettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else-if="jsonData.precedentiRicoveriTso === 'SI'">{{ jsonData.precedentiRicoveriTsoDettaglio }}</span>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            isPersonaRiferimento: true,
            jsonData: {},
            pathResourche: "/rsapazientesrprofilosanitariointegrativo",
            nomeProgetto: "PROFILO SANITARIO INTEGRATIVO",
            params: "",
            profiloSanitarioIntegrativoOptions: [
                { text: "- Seleziona Valore -", value: null },
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
                { text: "MANCANZA DI INFORMAZIONI", value: "MANCANZA DI INFORMAZIONI" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { profiloSanitarioIntegrativo: "SI" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            usoSostanze: null,
            params: me.params,
            nomeProgetto: me.nomeProgetto,
            dataInizio: new Date().getTime(),
            dataFine: null,
            precedentiRicoveriSpdc: null,
            precedentiRicoveriStrutturePrivate: null,
            precedentiRicoveriTso: null,
            familiaritaPatologica: null,
            alcolista: null,
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourche + "/" + me.idRisorsa, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        resultErrorData(error) {
            console.log(error.response.data.messaggio);
        },
    },
};
</script>
